// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const ProductListFilled: React.FC = () => {
    return <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 20 18" enableBackground="new 0 0 20 18" xmlSpace="preserve" fill="currentColor">
<path d="M14.65,0C12.72,0,11.02,0.87,10,2.19C8.98,0.87,7.28,0,5.35,0C2,0,0,2.87,0,5.65c0,6.31,9.11,11.67,9.5,11.9l0.5,0.29
	l0.5-0.29c0.39-0.23,9.5-5.59,9.5-11.9C20,2.48,17.65,0,14.65,0z M10,5.06L10,5.06L10,5.06L10,5.06z"/>
</svg>;
};

export default React.memo(ProductListFilled);
